export default __webpack_public_path__ + "static/media/Slide45.bf973908.PNG";